import { createContext, useContext, useState } from "react";

// Tracks which area + step the user is on so the Right Now bar (in the shell)
// can react to movement inside an area (in the page).
const RightNowContext = createContext(null);

export const RightNowProvider = ({ children }) => {
  const [position, setPosition] = useState({ areaId: null, stepIndex: 0 });
  return (
    <RightNowContext.Provider value={{ position, setPosition }}>
      {children}
    </RightNowContext.Provider>
  );
};

export const useRightNow = () => useContext(RightNowContext);
